<div class="background">
    <div class="text" data-qa="welcome-text">
        <span>
        Das TNB-Portal TDL ist eine webbasierte Anwendung für Netzbetreiber, die Stammdaten zu
        dezentralen Erzeugungsanlagen erfasst, validiert, netztechnisch zuordnet und für verschiedene
        Prozesse und Dienstleistungen bereitstellt.
        </span>
        @if ((displayLoginError$ | async) === false) {
            <button matButton="filled"
                    class="button-white login"
                    (click)="login()" data-qa="login-button">
                <mat-icon>launch</mat-icon>
                <span>Zum Login</span>
            </button>
        } @else {
            <span data-qa="login-error-text">
        Ein Zugriff auf die Anwendung ist mit Ihren Berechtigungen leider nicht möglich. Wenn Sie weiterhin Probleme haben, auf die Anwendung zuzugreifen, wenden Sie sich bitte an den Support.
      </span>
            <button matButton="filled" class="button-white login"
                    (click)="logout()" data-qa="logout-button">
                <mat-icon>launch</mat-icon>
                <span>Abmelden</span>
            </button>
        }
    </div>
</div>
